
export const FUEL_PRICE_BY_COUNTRY = {
  US: 1.21,    // USD per liter (as of August 2025)
  CA: 1.47,    
  MX: 1.08,    
  GT: 1.12,    
  HN: 1.10,    
  NI: 1.12,    
  CR: 1.15,    
  PA: 1.13,    
  CO: 1.10,    
  PE: 1.13,    
  EC: 1.12,    
  BR: 1.12,    
  AR: 1.10,    
};

export const DEFAULT_FUEL_PRICE = 1.3; // fallback

export const VEHICLE_FUEL_CONSUMPTION = {
  Motorbike: 3,        // liters per 100 km
  Car: 8,
  Truck: 25,
  Campervan: 15,
  CampervanLarge: 20,
  RV: 25,
  Unimog: 30,
  Walking: 0,
  Cycling: 0,
  Tuktuk: 5,
};